export const defaultState = {
  "en": {
    "Super  Second  from  Bordeaux  St-Julien x": "Super  Second  from  Bordeaux  St-Julien x",
  },
};

export function reducer(
  state: any = defaultState,
): any {
  return state;
}



// WEBPACK FOOTER //
// ./src/redux/remoteLocale.ts